import api from "../api";

export const getHabits = async () => {
  return api.getApi().get(api.getBaseUrl() + "habits");
};

export const getHabit = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `habits/${id}`);
};

export const createHabit = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "habits", data);
};

export const updateHabit = async (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `habits/${id}`, data);
};

export const deleteHabit = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `habits/${id}`);
};

export const checkInHabit = async (id, data) => {
  return api.getApi().post(api.getBaseUrl() + `habits/${id}/check-in`, data);
};

export const getHabitLogs = async (id, filters = {}) => {
  return api.getApi().get(api.getBaseUrl() + `habits/${id}/logs`, { params: filters });
};
